import { Component, NgZone, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { UserManagementService } from '../usermanagement.service';
import { InfoAlertService } from '../../shared/services/infoalert.service';
import { Store } from '@ngrx/store';
import * as fromApp from '../../store/reducers/app.reducers';
import * as AuthActions from '../store/auth.actions';
import { CasedashboardService } from 'src/app/case-dashboard/casedashboard.service';
import { AuthService } from 'src/app/shared/services/auth.service';
import { EventType } from 'src/app/shared/helpers/constants';
import { SharedStateService } from 'src/app/shared/services/shared-state.service';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {
  private userName: string;
  public errorFromConfirm: boolean;
  public userLoginErrRes: string;
  errUserDetails = {};
  userDetails: string;
  role: string;
  imageurl: string;
  userstorage: string;
  userInfo = {};
  auditAction = {};
  clpLoginUrl = '';
  openIDCode: string;
  userLoginRes = {};
  decodedToken: string;
  displaySpinner: boolean = true;
  eventOutcome: number;
  actionActivityDetails: string;
  errOutcome: number = 0;
  successOutcome: number = 1;
  codeVerifier: string = '';
  /**
   * (description): To initialize the required service for the component creates the login form when then object is instantiated
   * (memberof) : LoginComponent
   */
  constructor(
    private router: Router,
    private alertService: InfoAlertService,
    private translateService: TranslateService,
    private userService: UserManagementService,
    private store: Store<fromApp.AppState>,
    private casedashboardService: CasedashboardService,
    private authService: AuthService,
    private sharedState: SharedStateService,
    private activatedRoute: ActivatedRoute,
    private zone: NgZone
  ) {
    translateService.setDefaultLang('en');
    //To get user actions from json file
    this.sharedState.userActionStateData$.subscribe(response => {
      this.auditAction = response;
    });
    this.clpLoginUrl = environment.cloudFrontCLPSignInUrl;
    this.openIDCode = this.activatedRoute.snapshot.queryParamMap.get('code') as string;
    localStorage.setItem('tokenCode', JSON.stringify(this.openIDCode));
    const stateParam = this.activatedRoute.snapshot.queryParamMap.get('state') as string;
    if (stateParam) {
      const DELIMITER = ';';
      const [portal, verifierId] = stateParam.split(DELIMITER);
      this.codeVerifier = verifierId;
    }
  }

  ngOnInit(): void {
    if (localStorage.getItem('clpSession') != null) {
      this.getTokenCode();
    } else if (this.openIDCode && this.codeVerifier) {
      this.getTokenCode();
    } else {
      this.authService.logout();
    }
  }

  public getTokenCode() {
    this.displaySpinner = true;
    const code = this.openIDCode;
    if (code) {
            this.userService.fetchTokenCode(code, this.codeVerifier, (err: any, result: any) => {
              if (err) {
                this.userLoginErrRes = err;
                let cloudfrontCLPURL = environment.cloudFrontCLPSignInUrl;
                cloudfrontCLPURL = cloudfrontCLPURL.replace(/signin/g, 'application/product');
                window.location.href = cloudfrontCLPURL;
              }
              else {
                this.userLoginRes = result;
                let session = {};
                session['idToken'] = this.userLoginRes['id_token'];
                session['accessToken'] = this.userLoginRes['access_token'];
                session['refresh_token'] = this.userLoginRes['refresh_token'];
                session['surgeonId'] = this.userLoginRes['userName'];
                localStorage.setItem('clpSession', JSON.stringify(session));
                this.integrationLogin();
              }
            });

            this.codeVerifier = '';
    }
    else {
      this.authService.signOut();
    }

  }

  async integrationLogin() {
    let idToken = this.authService.getCognitoIdTokenFromStorage();
    this.decodedToken = this.authService.decode(idToken);
    this.userName = this.decodedToken['cognito_old_username'] ? this.decodedToken['cognito_old_username'] : this.decodedToken['cognito:username'];
    let ssmIdleTime = await this.authService.getSSMValue(environment.ssmParams.IDLETIME);  
    this.sharedState.ssmIdleTimeVal(ssmIdleTime);    
    this.getLoggedInUser(this.userName);
  }

  /**
   * (description): To call remove confirm error function
   * (memberof) : Component
  **/
  public removeConfirmError() {
    if (this.errorFromConfirm) {
      this.store.dispatch(new AuthActions.SendConfirmError(true));
    }
  }
  /**
   * (description): To call loggedIn user details API call
   * (memberof) : Component
  **/
  public getLoggedInUser(UserName): any {
    this.displaySpinner = true;
    this.casedashboardService.getLoggedInDetails(UserName).subscribe({
      next: result => {
        this.userInfo = result;
        this.userDetails = result.userFirstName?.slice(0, 1) + ' ' + result.userLastName;
        this.role = result.userRole;
        this.imageurl = result.profilePic;
        this.userstorage = result.userName;
        this.authService.setItem('userDetails', JSON.stringify(result));
        let dt = Date.now();
        sessionStorage.setItem('isSessionActive', "" + dt);
        this.zone.run(() => {
          this.router.navigate(['/activecase']);
        });       
        this.auditLogActivity(this.successOutcome, EventType.read)
      },
      error: error => {
        this.errUserDetails = error;
        this.auditLogActivity(this.errOutcome, EventType.read);
      }
    })
  }
  auditLogActivity(outcome, eventName) {
    let auditLogTime = new Date();
    this.eventOutcome = outcome;
    let action = {
      "dateTime": auditLogTime,
      "userName": this.userstorage,
      "action": this.userInfo ? this.auditAction["UserActions"].loginLaunch + this.auditAction["UserActions"].loginAction + this.auditAction["UserActions"].loggedInSuccess : this.auditAction["UserActions"].loggedInFailure,
      "eventOutCome": this.eventOutcome ? 1 : 0,
      "eventType": eventName
    };
    this.casedashboardService.auditLogActivity(action).subscribe({
      next: Response => {
        let result = Response;
        this.actionActivityDetails = result;
      },
      error: error => {
        this.errUserDetails = error;
      }
    });
  }
}
